let routes = [
    // 己二酸
    {
        path: 'adipic',
        name: '己二酸',
        component: () => import('@/views/adipic/index'),
    },
    {
        path: 'adipic/twoPage/industry',
        name: '己二酸行业动态二级页',
        component: () => import('@/views/adipic/twoPage/industry')
    },
    {
        path: 'adipic/industry',
        name: '己二酸行业动态详情页',
        component: () => import('@/views/adipic/detail/industry')
    },
    {
        path: 'adipic/twoPage/dynamic',
        name: '己二酸企业动态二级页',
        component: () => import('@/views/adipic/twoPage/dynamic')
    },
    {
        path: 'adipic/dynamic',
        name: '己二酸企业动态详情页',
        component: () => import('@/views/adipic/detail/dynamic')
    },
    {
        path: 'adipic/twoPage/yield',
        name: '己二酸产量二级页',
        component: () => import('@/views/adipic/twoPage/yield')
    },
    {
        path: 'adipic/yield',
        name: '己二酸产量详情页',
        component: () => import('@/views/adipic/detail/yield')
    },
    {
        path: 'adipic/twoPage/downstream',
        name: '己二酸下游动态二级页',
        component: () => import('@/views/adipic/twoPage/downstream')
    },
    {
        path: 'adipic/downstream',
        name: '己二酸下游动态详情页',
        component: () => import('@/views/adipic/detail/downstream')
    },
    {
        path: 'adipic/twoPage/stock',
        name: '己二酸库存二级页',
        component: () => import('@/views/adipic/twoPage/stock')
    },
    {
        path: 'adipic/stock',
        name: '己二酸库存详情页',
        component: () => import('@/views/adipic/detail/stock')
    },
    {
        path: 'adipic/twoPage/price',
        name: '己二酸价格二级页',
        component: () => import('@/views/adipic/twoPage/price')
    },
    {
        path: 'adipic/price',
        name: '己二酸价格详情页',
        component: () => import('@/views/adipic/detail/price')
    },
    {
        path: 'adipic/backPrice',
        name: '己二酸后两个价格详情页',
        component: () => import('@/views/adipic/detail/backPrice')
    },
    {
        path: 'adipic/twoPage/report',
        name: '己二酸研究报告二级页',
        component: () => import('@/views/adipic/twoPage/report')
    },
    {
        path: 'adipic/twoPage/standard',
        name: '己二酸技术及标准二级页',
        component: () => import('@/views/adipic/twoPage/standard')
    },
    {
        path: 'adipic/map',
        name: '己二酸地图',
        component: () => import('@/views/adipic/detail/map.vue')
    },
]

export default routes;
